<template>
	<div class="pui-form">
		<v-form class="pui-motivoanulrechform mb-4 pb-4" ref="form" v-model="valid" lazy-validation @submit.prevent v-if="modelLoaded">
			<motivo-anul-rech-modals :modelName="modelName"></motivo-anul-rech-modals>
			<v-layout>
				<v-flex xs8>
					<pui-field-set>
						<v-layout wrap class="pui-form-layout">
							<v-flex xs12>
								<pui-radio-group
									id="entidad"
									:label="$t('motivoanulrech.entidad')"
									row
									:disabled="this.method != 'create'"
									:radios="entidades"
									required
									v-model="entSelected"
								></pui-radio-group>
							</v-flex>
							<v-flex xs12>
								<pui-radio-group
									id="tipo"
									:label="$t('motivoanulrech.tipo')"
									row
									:radios="tipos"
									:disabled="this.method != 'create'"
									required
									v-model="tipoSelected"
								></pui-radio-group>
							</v-flex>
							<v-flex xs12>
								<pui-text-field
									:label="$t('motivoanulrech.codigo')"
									v-model="model.codigo"
									maxlength="2"
									required
									:disabled="this.method != 'create'"
									valueColumnStyles="xs4 sm2 md1"
								></pui-text-field>
							</v-flex>
							<v-flex xs12>
								<pui-text-field
									:label="$t('motivoanulrech.descripcion')"
									v-model="model.descripcion"
									maxlength="100"
									required
									:disabled="formDisabled"
								></pui-text-field>
							</v-flex>
							<v-flex xs12 v-if="this.method != 'create'">
								<pui-checkbox
									:label="$t('motivoanulrech.indbaja')"
									v-model="model.indbaja"
									:trueValue="'1'"
									:falseValue="'0'"
									disabled
								></pui-checkbox>
							</v-flex>
						</v-layout>
					</pui-field-set>
				</v-flex>
			</v-layout>

			<pui-form-footer>
				<v-layout>
					<v-flex xs12 sm12 md8 lg8 xl8>
						<v-layout>
							<v-flex xs12 md4>
								<!--<pui-form-mini-audit class="pl-2" :model="model" v-if="this.method !== 'create'"></pui-form-mini-audit>-->
							</v-flex>
							<v-flex xs12 md8>
								<v-layout justify-end fill-height>
									<v-btn v-if="!formDisabled" depressed color="secondary" class="elevation-0" @click.native="save(false)">{{
										this.$t('form.save')
									}}</v-btn>

									<v-btn text outlined @click.native="back()">{{ $t('form.cancel') }}</v-btn>
								</v-layout>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-layout>
			</pui-form-footer>
		</v-form>
		<pui-form-loading v-else></pui-form-loading>
	</div>
</template>

<script>
import PuiFormMethodsMixin from 'pui9-mixins/PuiFormMethodsMixin';
import MotivoAnulRechActions from './MotivoAnulRechActions';
import MotivoAnulRechModals from './MotivoAnulRechModals';

export default {
	name: 'motivoanulrech',
	mixins: [PuiFormMethodsMixin],
	components: { MotivoAnulRechModals },
	data() {
		return {
			modelName: 'motivoanulrech',
			actions: MotivoAnulRechActions.formactions,
			entSelected: 0,
			entidades: [
				{
					id: 0,
					label: this.$t('motivoanulrech.encargo')
				},
				{
					id: 1,
					label: this.$t('motivoanulrech.libramiento')
				}
			],
			tipoSelected: 0,
			tipos: [
				{
					id: 0,
					label: this.$t('motivoanulrech.anulacion')
				},
				{
					id: 1,
					label: this.$t('motivoanulrech.rechazo')
				}
			]
		};
	},
	methods: {
		// override
		beforeSave() {
			this.formatEntidad(this.entSelected);
			this.formatTipo(this.tipoSelected);
		},
		// override
		afterGetData() {
			if (this.model.tipo != null) this.formatTipo(this.model.tipo);
			else this.model.tipo = 'A';
			if (this.model.entidad != null) this.formatEntidad(this.model.entidad);
			else this.model.entidad = 'E';
		},
		formatTipo: function (value) {
			if (value === 1 || value === 'R') {
				this.model.tipo = 'R';
				this.tipoSelected = 1;
			} else {
				this.model.tipo = 'A';
				this.tipoSelected = 0;
			}
		},
		formatEntidad: function (value) {
			if (value === 1 || value === 'L') {
				this.model.entidad = 'L';
				this.entSelected = 1;
			} else {
				this.model.entidad = 'E';
				this.entSelected = 0;
			}
		}
	},
	mounted() {
		this.$puiEvents.$on(`refreshForm-action-running-ended-${this.modelName}`, () => {
			//Para hacer recarga de la pantalla del form al realizar una accion
			this.modelLoaded = false;
			this.onReady();
		});
	},
	destroyed() {
		this.$puiEvents.$off(`refreshForm-action-running-ended-${this.modelName}`);
	}
};
</script>

<style scoped></style>

<i18n>
{
	"en": {
        "motivoanulrech.entidad": "Entity",
        "motivoanulrech.tipo": "State",
        "motivoanulrech.codigo": "Code",
        "motivoanulrech.descripcion": "Description",

		"motivoanulrech.libramiento": "Riddance",
		"motivoanulrech.encargo": "Order",
		"motivoanulrech.anulacion": "Annulment",
		"motivoanulrech.rechazo": "Rejection"
    },
    "es": {
        "motivoanulrech.entidad": "Entidad",
        "motivoanulrech.tipo": "Estado",
        "motivoanulrech.codigo": "Código",
        "motivoanulrech.descripcion": "Descripción",

		"motivoanulrech.libramiento": "Libramiento",
		"motivoanulrech.encargo": "Encargo",
		"motivoanulrech.anulacion": "Anulación",
		"motivoanulrech.rechazo": "Rechazo"
    },
    "ca": {
        "motivoanulrech.entidad": "Entitat",
        "motivoanulrech.tipo": "Estat",
        "motivoanulrech.codigo": "Codi",
        "motivoanulrech.descripcion": "Descripció",

		"motivoanulrech.libramiento": "Lliurament",
		"motivoanulrech.encargo": "Encàrrec",
		"motivoanulrech.anulacion": "Anul·lació",
		"motivoanulrech.rechazo": "Rebuig"
    }
}
</i18n>
